import React, { useState } from 'react';
import { supabase } from '../services/supabase';
import '../styles/ApplicationStatusPage.css';

const ApplicationStatusPage = () => {
  const [voen, setVoen] = useState('');
  const [application, setApplication] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCheck = async (e) => {
    e.preventDefault();
    setError('');
    setApplication(null);
    setLoading(true);

    try {
      const { data, error } = await supabase
        .from('business_applications')
        .select('*')
        .eq('voen', voen)
        .single();

      if (error) throw error;

      if (!data) {
        setError('Bu VÖEN ilə müraciət tapılmadı');
        return;
      }

      setApplication(data);
    } catch (error) {
      console.error('Check status error:', error);
      setError('Müraciət tapılmadı və ya xəta baş verdi');
    } finally {
      setLoading(false);
    }
  };

  const getStatusInfo = (status) => {
    const statuses = {
      pending: {
        icon: '⏳',
        text: 'Gözləmədə',
        color: '#f39c12',
        description: 'Müraciətiniz yoxlanılır'
      },
      approved: {
        icon: '✅',
        text: 'Təsdiqlənib',
        color: '#27ae60',
        description: 'Müraciətiniz təsdiqlənib! Giriş edə bilərsiniz'
      },
      rejected: {
        icon: '❌',
        text: 'Rədd edilib',
        color: '#e74c3c',
        description: 'Müraciətiniz rədd edilib'
      }
    };
    return statuses[status] || statuses.pending;
  };

  return (
    <div className="status-container">
      <div className="status-box">
        <div className="status-header">
          <h1>☕ Cafegoo</h1>
          <p>Müraciət Statusu</p>
        </div>

        {!application ? (
          <form onSubmit={handleCheck} className="status-form">
            <div className="form-group">
              <label>VÖEN Daxil Edin</label>
              <input
                type="text"
                value={voen}
                onChange={(e) => setVoen(e.target.value)}
                placeholder="1234567890"
                maxLength="10"
                required
              />
              <small>Qeydiyyat zamanı daxil etdiyiniz VÖEN</small>
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="check-button" disabled={loading}>
              {loading ? 'Yoxlanılır...' : '🔍 Yoxla'}
            </button>

            <div className="back-link">
              <a href="/login">← Giriş səhifəsinə qayıt</a>
            </div>
          </form>
        ) : (
          <div className="status-result">
            {(() => {
              const statusInfo = getStatusInfo(application.status);
              return (
                <>
                  <div className="status-icon" style={{ color: statusInfo.color }}>
                    {statusInfo.icon}
                  </div>
                  <h2 style={{ color: statusInfo.color }}>{statusInfo.text}</h2>
                  <p className="status-description">{statusInfo.description}</p>

                  <div className="application-details">
                    <div className="detail-row">
                      <span className="detail-label">Şirkət:</span>
                      <span className="detail-value">{application.company_name}</span>
                    </div>
                    <div className="detail-row">
                      <span className="detail-label">Email:</span>
                      <span className="detail-value">{application.email}</span>
                    </div>
                    <div className="detail-row">
                      <span className="detail-label">Müraciət tarixi:</span>
                      <span className="detail-value">
                        {new Date(application.created_at).toLocaleDateString('az-AZ')}
                      </span>
                    </div>

                    {application.status === 'rejected' && application.rejection_reason && (
                      <div className="rejection-reason">
                        <strong>Rədd səbəbi:</strong>
                        <p>{application.rejection_reason}</p>
                      </div>
                    )}

                    {application.status === 'approved' && (
                      <div className="approval-info">
                        <p>✅ İndi giriş edə bilərsiniz!</p>
                        <a href="/login" className="login-link">Daxil ol →</a>
                      </div>
                    )}
                  </div>

                  <button
                    className="check-another-button"
                    onClick={() => {
                      setApplication(null);
                      setVoen('');
                    }}
                  >
                    Başqa müraciət yoxla
                  </button>
                </>
              );
            })()}
          </div>
        )}
      </div>
    </div>
  );
};

export default ApplicationStatusPage;